module.exports = __webpack_public_path__ + "static/media/banner1.c74c60d1.jpg";